<template>
    <div>
        <div class="box">
            <div>还剩余额</div>
            <div>￥20</div>
        </div>
        <div class="item">
            <input type="number" placeholder="请输入充值金额" v-model="price">
            <button @click="rechargeCard">立即充值</button>
            <div class="info">温馨提示：充值过程中若出现问题请联系商城客服</div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            price:''
        }
    },

    methods:{
        rechargeCard(){
            if(this.price.length == 0){ return this.$dialog.error("请输入金额");}
            if(!(/(^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*|([0-9]+\.[0-9]{2})[0-9]*))$)/.test(this.price))){
                return this.$dialog.error("请输入数字");
            }
        }
    }
}
</script>
<style scoped>
.box{
    width: 100%;
    height: 150px;
    background-color: #ef2020;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
}

.box text {
    display: block;
    width: 100%;
}

.box div:first-child {
    font-size: 18px;
    margin: 50px 0 10px 0;
}

.item{
    width: 100%;
    height: 420px;
    background-color: #fff;
    margin: 20px auto 0 auto;
    padding: 15px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    margin-top: -25px;
    display: flex;
    flex-direction: column;
}

.item input{
    width: 80%;
    height: 30px;
    padding-left: 8px;
    font-size: 13px;
    margin: 20px auto;
    border: 1px solid #ef2020;
    border-radius: 6px;
}   

.item button{
    width: 80%;
    height: 30px;
    margin: 10px auto;
    background-color: #ef2020;
    border-radius: 6px;
    color: #fff;
}

.info{
    margin-top: 40px;
    text-align: center;
}
</style>